import React, {FC, useState} from 'react';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleActionInstruction} from '../common/infoBubbles/infoBubbleActionInstruction';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const GuidedDemoComposerSendInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();

  // State and helpers necessary to animate the action instruction on outside click.
  const [isActionInstructionAnimated, setIsActionInstructionAnimated] = useState<boolean>(false);
  const triggerActionInstructionAnimation = () => {
    setIsActionInstructionAnimated(true);
  };
  const onActionInstructionAnimationEnd = () => {
    setIsActionInstructionAnimated(false);
  };

  return (
    <InfoBubble
      {...context}
      type={OnboardingTipTypesEnum.GUIDED_DEMO_COMPOSER_SEND}
      position="top"
      targetRef={targetRef}
      onOutsideHighlightClick={triggerActionInstructionAnimation}
      isStandalone
      hasHighlightPulse
    >
      <InfoBubbleContent>
        <InfoBubbleTitle>
          <Trans id="infobubble-guideddemocomposersend-title">Send and Archive</Trans>
        </InfoBubbleTitle>
        <Trans id="infobubble-guideddemocomposersend-description">
          Archiving keeps your inbox clear to help you focus. It&apos;s like crossing off tasks on a to-do
          list.
        </Trans>
        <InfoBubbleActionInstruction
          isAnimated={isActionInstructionAnimated}
          onAnimationEnd={onActionInstructionAnimationEnd}
          iconName="sendFilledSmall"
          text={
            <Trans id="infobubble-guideddemocomposersend-instruction">
              Click &quot;Send and Archive&quot;
            </Trans>
          }
        />
      </InfoBubbleContent>
    </InfoBubble>
  );
};
